import { coreBeamerClient } from 'app/api/apiClient/generated/coreBeamerClient';
import { queries } from 'app/constants/queries';
import { useQueryEnhanced } from 'app/hooks/useQueryEnhanced';

import { useGetUser } from './auth/user';

export const useGetBeamerSegments = () => {
  const user = useGetUser();

  return useQueryEnhanced(
    [queries.beamerSegments],
    coreBeamerClient.getSegments,
    {
      enabled: !!user,
    },
  );
};
